import { Switch } from '@/components/ui/switch'
import { useUISettingsStore } from '@/store/useUISettingsStore'

import { SkimLegend, SkimLevelSegment } from './skim-level-ui'

const SettingRow = ({
  label,
  description,
  checked,
  onCheckedChange,
}: {
  label: string
  description: string
  checked: boolean
  onCheckedChange: (checked: boolean) => void
}) => (
  <label className="flex items-center justify-between gap-3">
    <span className="min-w-0">
      <span className="block text-sm font-medium">{label}</span>
      <span className="block text-xs text-muted-foreground">{description}</span>
    </span>
    <Switch checked={checked} onCheckedChange={onCheckedChange} />
  </label>
)

/** 本文への印と知らせの設定（シートのヘッダーの歯車から開く） */
export const ReaderAiSettings = () => {
  const skimMode = useUISettingsStore((state) => state.readerSkimMode)
  const setSkimMode = useUISettingsStore((state) => state.setReaderSkimMode)
  const skimLevel = useUISettingsStore((state) => state.readerSkimLevel)
  const setSkimLevel = useUISettingsStore((state) => state.setReaderSkimLevel)
  const sectionPreview = useUISettingsStore((state) => state.readerSectionPreview)
  const setSectionPreview = useUISettingsStore((state) => state.setReaderSectionPreview)
  const purposeMarks = useUISettingsStore((state) => state.readerPurposeMarks)
  const setPurposeMarks = useUISettingsStore((state) => state.setReaderPurposeMarks)

  return (
    <div className="space-y-3 rounded-xl bg-muted/50 p-3">
      <SettingRow
        label="流し読みモード"
        description="章の重要な文の横の余白に色付きの線と印（核・要）を付け、シークバーにも同じ色の印を出します（自分のハイライトとは別）"
        checked={skimMode}
        onCheckedChange={setSkimMode}
      />
      {skimMode && (
        <div className="space-y-2">
          <SkimLevelSegment value={skimLevel} onChange={setSkimLevel} />
          <SkimLegend />
        </div>
      )}
      <SettingRow
        label="目的に効く箇所に印を付ける"
        description="読む目的を決めた本で、目的に効く箇所の行頭側の余白に紫の帯を付けます（PDF はシークバーにも印を出します）"
        checked={purposeMarks}
        onCheckedChange={setPurposeMarks}
      />
      <SettingRow
        label="章のポイントを知らせる"
        description="新しい章に入ったとき、上部にポイントへの入口を出します"
        checked={sectionPreview}
        onCheckedChange={setSectionPreview}
      />
    </div>
  )
}
